<script>
import { mapState, mapActions } from 'vuex';
import dateMixin from '../../mixins/dateMixin';

export default {
  name: 'ChannelsDataTable',
  mixins: [
    dateMixin,
  ],
  data() {
    return {
      headers: [
        { text: 'ID', value: 'id', sortable: false },
        { text: 'Channel', value: 'webservice', sortable: false },
        { text: 'System', value: 'name', sortable: false },
        { text: 'Currency', value: 'currency', sortable: false },
        { text: 'Type', value: 'type', align: 'right', sortable: false },
        { text: 'Action', value: 'action', align: 'right', sortable: false },
      ],
    };
  },
  methods: {
    ...mapActions({
      selectChannel: 'prices/selectChannel',
      selectType: 'prices/selectType',
    }),
    channelSelected(selected) {
      this.selectChannel(selected);
      if (selected.isOTA) {
        this.selectType({ type: 'push', id: '' });
      }
    },
  },
  computed: {
    ...mapState({
      channels: state => state.prices.channels,
      list: state => state.prices.list,
    }),
    getStatusMessage() {
      if (this.list.error) {
        return this.list.errorMessage;
      }
      return !this.list.noContent
        ? 'Search for prices by using the filter'
        : 'No content were found with that filter';
    },
  },
};
</script>

<template>
  <v-data-table
    :headers="headers"
    :items="channels.items"
    :loading="list.loading"
    class="elevation-1"
    hide-actions
  >
    <template v-slot:no-data>
      <tr>
        <td
          v-if="!list.loading"
          :colspan="headers.length"
          class="text-xs-center"
        >
          {{ getStatusMessage }}
        </td>
        <td v-if="list.loading" :colspan="headers.length" class="text-xs-center">Searching...</td>
      </tr>
    </template>
    <template v-if="!list.loading" v-slot:items="channel">
      <td>{{ channel.item.id }}</td>
      <td>{{ channel.item.webservice }}</td>
      <td>{{ channel.item.name }}</td>
      <td>{{ channel.item.currency }}</td>
      <td align="right">
        <v-chip
          :color="channel.item.isOTA ? 'light-blue' : 'primary'"
          text-color="white"
        >
          {{ channel.item.isOTA ? 'Push' : 'Import' }}
        </v-chip>
      </td>
      <td align="right">
        <v-btn @click="channelSelected(channel.item)" color="primary" outline>
          Select
        </v-btn>
      </td>
    </template>
  </v-data-table>
</template>



// WEBPACK FOOTER //
// src/components/prices/ChannelsDataTable.vue